<template>
	<td :class="[
			'text-no-wrap',
			'text-center',
			'caption',
			grey ? 'primary--text text--lighten-4' : ''
		]"
		style="height: 36px;"
	>
		<v-row>
			<v-col cols="6"></v-col>
			<v-col cols="6" class="py-1">
				<template v-if="editMode">
					<v-menu
						v-model="deliveryDateMenu"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<a-text-field-inline
								:value="computedValue"
								class="caption"
								readonly
								:a-on="on"
							></a-text-field-inline>
						</template>
						<v-date-picker
							v-if="deliveryDateMenu && editMode"
							:value="value"
							locale="ru-RU"
							first-day-of-week="1"
							:show-current="true"
							no-title
							scrollable
							@input="input"
						></v-date-picker>
					</v-menu>
				</template>
				<template v-else>
					{{ computedValue }}
				</template>
			</v-col>
		</v-row>
	</td>
</template>

<script>
	import { dateFormat } from '../../../js/common'
	import aTextFieldInline from '../../base/ATextFieldInline.vue'

	export default {
		components: {
			aTextFieldInline,
		},
		props: {
			value: [String, Number],
			editMode: Boolean,
			grey: Boolean,
		},
		computed: {
			computedValue() {
				return dateFormat(this.value)
			}
		},
		data: function() {
			return {
				deliveryDateMenu: false
			}
		},
		methods: {
			input(e) {
				this.deliveryDateMenu = false
				this.$emit('input', e)
			}
		}
	}
</script>

<style scoped>

</style>
